<era-device-sync-status-ui [deviceStatus]="deviceStatus()"> </era-device-sync-status-ui>